import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CallCenterService {

    public selectedAgent = new BehaviorSubject(null);
    getSelectedAgent = this.selectedAgent.asObservable();

    public selectedEmployer = new BehaviorSubject(null);
    getSelectedEmployer = this.selectedEmployer.asObservable();

    setSelectedAgent(agent: any) {
        this.selectedAgent.next(agent);
    }

    setSelectedEmployer(employer: any) {
        this.selectedEmployer.next(employer);
    }
}